import React from 'react';
import {
  Redirect,
  Route,
  RouteProps as ReactDOMRouteProps,
} from 'react-router-dom';
import { useAuth } from '../hooks/auth';

interface RouteProps extends ReactDOMRouteProps {
  component: React.ComponentType;
}

const PrivateRoute: React.FC<RouteProps> = ({
  component: Component,
  ...rest
}) => {
  const { token } = useAuth();
  localStorage.removeItem('DataFilter');
  return (
    <Route
      {...rest}
      render={() => {
        return token.access_token ? <Component /> : <Redirect to="/" />;
      }}
    />
  );
};

export default PrivateRoute;
